import { FormsModule } from '@angular/forms';
import { NbCardModule, NbDialogRef, NbThemeModule, NbDialogService, NbButtonModule, NbLayoutModule } from '@nebular/theme';
import { environment } from '../environments/environment';
import { authEnvironment } from '../environments/auth-environment';
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, Injector, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbCalendarModule,
  NbWindowModule
} from '@nebular/theme';
//import { MedicalRecordServiceModule } from './services/manage-medical-record/medical-record.service.module';
import { HttpConfigInterceptor } from './services/httpconfig.interceptor';
import { MomentModule } from 'ngx-moment';
import { ServiceModule } from './services/services.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AlertDialogService } from './services/alertDialog.service';
import { ConfirmDialogComponent } from './shared/components/confirm-dialog/confirm-dialog.component';
import { PendingChangesGuard } from './shared/components/can-deactivate/can-deactivate.component';
import api from './services/api'
import {
  NbPasswordAuthStrategy, NbAuthModule, NbAuthJWTToken, NbAuthSimpleToken, NbAuthOptions,
  NB_AUTH_USER_OPTIONS, NB_AUTH_OPTIONS, NB_AUTH_STRATEGIES, nbStrategiesFactory, nbOptionsFactory
} from '@nebular/auth';
import { NgxAuthComponent } from './auth/auth.component';
import { NgxLoginComponent } from './auth/login/login.component';
import { APP_BASE_HREF } from '@angular/common';
import { NbSecurityModule, NbRoleProvider } from '@nebular/security';
import { AppConfig } from './services/app.config.service';
import { AppRoleProvider } from './role.provider';
import { AuthGuard } from './auth.guard';
import { DragDropModule } from '@angular/cdk/drag-drop';
const formSetting: any = {
  redirectDelay: 0,
  showMessages: {
    success: true,
  },
  rememberMe: true,
};
@NgModule({
  declarations: [
    AppComponent,
    ConfirmDialogComponent,
    //NgxAuthComponent,
    //NgxLoginComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbLayoutModule,
    //MedicalRecordServiceModule,
    MomentModule.forRoot(),
    ThemeModule.forRoot(),
    NbButtonModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    ServiceModule.forRoot(),
    NbCardModule,
    FormsModule,
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    //NbSecurityModule.forRoot({}),
  ],
  providers: [
    NbDialogService,
    AlertDialogService,
    PendingChangesGuard,
    AuthGuard,
    { provide: APP_BASE_HREF, useValue: '/' },
    //{ provide: NbRoleProvider, useClass: AppRoleProvider },
    AppConfig, { provide: APP_INITIALIZER, useFactory: initConfig, deps: [AppConfig], multi: true },
    //{ provide: NB_AUTH_OPTIONS, useFactory: nbOptionsFactory, deps: [NB_AUTH_USER_OPTIONS] },
    //{ provide: NB_AUTH_STRATEGIES, useFactory: nbStrategiesFactory, deps: [NB_AUTH_OPTIONS, Injector] },
  ],

  entryComponents: [ConfirmDialogComponent],
  bootstrap: [AppComponent],
})
export class AppModule {
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
export function initConfig(appConfig: AppConfig) {
  return () => appConfig.load();
}
